import React from 'react';
import InstructionWrap from '../../../../components/InstructionWrap';
import StepItemVisa from '../../../../components/StepItemVisa';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getVisaServiceId } from '../function';

const BusinessMultiple = ({ i18n, visaServiceList }) => {
  const visaServiceId = getVisaServiceId(visaServiceList, 'bussiness_multiple');

  return (
    <div className='card-instruction-detail'>
      <div className='title'>{i18n('visa_page.tab6.title')}</div>
      <main>
        <StepItemVisa
          instructions={i18n('visa_page.tab6.step.instruction2')}
          i18n={i18n}
          type='bussiness_multiple'
          serviceId={visaServiceId}
        />
        <InstructionWrap
          instruction={i18n('visa_page.tab6.step.instruction1')}
          instructionList={i18n('visa_page.instruction_step.bus_multi_req')}
          type='number'
        />
      </main>
    </div>
  );
};

BusinessMultiple.propTypes = {
  i18n: PropTypes.func,
  visaServiceList: PropTypes.array
};

const mapStateToProps = (state) => ({
  i18n: state.langReducer.i18n
});

export default connect(mapStateToProps)(BusinessMultiple);
